<template>
  <base-modal ref="modal" size="md">
    <base-card shadow>
      <div>
        <div class="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100">
          <alert-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center tw-sm:mt-5">
          <h3 class="tw-text-lg tw-leading-6 tw-font-thin tw-text-gray-900">
            {{ title }}
          </h3>
          <div class="tw-mt-2">
            <p class="tw-text-sm tw-font-thin tw-text-gray-500">
              {{ message }}
            </p>
            <p v-if="errorMessage" class="tw-mt-3 tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6 tw-text-sm tw-font-thin tw-text-red-600 tw-bg-red-100 tw-rounded-md tw-text-left">
              {{ errorMessage }}
            </p>
          </div>
          <div class="tw-mt-4">
            <base-button color="red" type="flat" @click="hide">Dismiss</base-button>
          </div>
        </div>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { AlertIcon } from "@/assets/svgs";
import errormessage from "@/mixins/errormessage";

export default {
  mixins: [errormessage],
  components: {
    AlertIcon,
  },
  data() {
    return {
      title: null,
      message: null,
      error: null,
      showDetails: true,
    };
  },
  computed: {
    errorMessage() {
      return this.error ? this.getErrorMessage(this.error) : "No Details Available :(";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  created() {
    this.EventBus.$on("GLOBAL_ERROR", (payload) => {
      this.showDetails = true;
      this.title = payload.title;
      this.message = payload.message;
      this.error = payload.error;

      this.show();

      throw payload.error;
    });
  },
};
</script>
